module.exports = __webpack_public_path__ + "static/img/chanta (19).d718fe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (19).jpg
// module id = TZ2c
// module chunks = 0